<template>
	<div class="field__group">
		<label :for="_uid" class="hidden">{{ label + ((required)?'*':'') }}</label>
		<input :class="{error: errors && errors.length > 0}" :type="(type)?type:'text'" :name="_uid" :id="_uid" :placeholder="label + ((required)?'*':'')" v-model="text" :inputmode="inputmode" :min="min" :max="max" :step="step" />
		<input-errors :errors="errors"></input-errors>
	</div>
</template>

<script>
	export default {
		props: ['value', 'label', 'required', 'errors', 'type', 'inputmode', 'min', 'max', 'step'],
		data() {
			return {
				text: this.value
			};
		},
		watch: {
			text() {
				this.$emit('input', this.text);
			},
			value() {
				this.text = this.value;
			}
		}
	}
</script>